module.exports = __webpack_public_path__ + "img/placeholder_image.2fccf727.png";